<template>
  <div class="container">
    <common-head></common-head>
    <div class="inner">
      <div class="account-page">
        <account-left></account-left>
        <div class="act-page-right">
          <div class="act-c-bd">
            <div class="item">
              <div class="hd-title">Browsing history</div>
              <div class="table-con">
                <el-table :data="pageData" stripe style="width: 100%"
                  :default-sort="{ prop: 'date', order: 'descending' }">
                  <el-table-column prop="CreatedTime" label="Date" width="180" sortable fixed></el-table-column>
                  <el-table-column prop="ProductTypeText" label="Type" width="180" sortable></el-table-column>
                  <el-table-column prop="Name" label="Name"></el-table-column>
                  <el-table-column label="Operate" width="100" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click="openProductUrl(scope.row)" type="text" size="small">view</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination layout="prev, pager, next, jumper, total, sizes" class="m-page-list" background
                  @current-change="changePage" :current-page="pageNo" :page-sizes="[10, 20, 30, 40, 50, 100]"
                  :page-size="pageSize" :total="pageTotal">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <common-foot></common-foot>
  </div>
</template>

<script>
import CommonHead from "common/head/Head";
import CommonFoot from "common/foot/Foot";
import AccountLeft from "common/other/AccountLeft";
export default {
  name: "FootPrint",
  components: {
    CommonHead,
    CommonFoot,
    AccountLeft,
  },
  data() {
    return {
      pageData: [],
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      businessType: [],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    changePage(val) {
      this.pageNo = val;
      this.loadData();
    },

    loadData() {
      let userInfo = this.jwt_decode(window.localStorage.Token);
      var params = {
        page: this.pageNo,
        rows: this.pageSize,
        wheres: { BUSINESSTYPE: "" },
      };
      this.$bti.GetBrowsePage(params).then((res) => {
        this.pageData = res.data.rows;
        this.pageTotal = res.data.total;
        for (var i = 0; i < this.pageData.length; i++) {
          if (this.pageData[i].EBOOKID) {
          } else {
            this.pageData[i].EBOOKNAME = this.pageData[i].SOUNDBOOKNAME;
            this.pageData[i].EBOOKID = this.pageData[i].SOUNDBOOKID;
          }
        }
      });
    },
    openProductUrl(row) {

      var params = {
        Id: row.Id,
        type: row.ProductType,
        status: row.SOURCEOPENTYPE,
      };

      if (row.ProductType === 1) {
        window.location.href = "/detail/dzDetail/" + row.Id;
      } else if (row.ProductType === 2) {
        window.location.href = "/detail/ysDetail/" + row.Id;
      }


      // this.$bti.GetReadBook(params).then((res) => {
      //   if (!res.data) {
      //     this.$message({ type: "error", message: "this book deleted!" });
      //     return;
      //   } else {
      //     if (row.ProductType === 1) {
      //       window.location.href = "/detail/dzDetail/" + row.Id;
      //     } else if (row.ProductType === 2) {
      //       window.location.href = "/detail/ysDetail/" + row.Id;
      //     }
      //   }
      // });
    },
  },
};
</script>

<style lang="css" scoped>
.act-c-bd .hd-title {
  font-size: 16px;
  font-weight: bold;
  height: 35px;
  line-height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/pages/footprint/FootPrint.vue